module.exports = __webpack_public_path__ + "static/media/028.32e8038f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/028.jpg
// module id = 501
// module chunks = 0